import { Button, Flex } from 'antd'
import { RefreshCcw, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { AuthLink } from '../AuthLink'

type QrFullActionsProps = {
  isTerminal: boolean
  isApproved: boolean
  hasSession: boolean
  isStarting: boolean
  showPasswordToggle?: boolean
  onCancel: () => void
  onRetry: () => void
  onSwitchToPassword?: () => void
}

export const QrFullActions = ({
  isTerminal,
  isApproved,
  hasSession,
  isStarting,
  showPasswordToggle,
  onCancel,
  onRetry,
  onSwitchToPassword
}: QrFullActionsProps) => {
  const { t } = useTranslation()

  return (
    <Flex orientation="vertical" gap={12}>
      {isTerminal && (
        <Button
          type="primary"
          size="large"
          icon={<RefreshCcw size={18} />}
          onClick={onRetry}
          loading={isStarting}
        >
          {t('auth.qrSignIn.tryAgain')}
        </Button>
      )}

      {!isTerminal && !isApproved && (
        <Button
          size="large"
          icon={<X size={18} />}
          onClick={onCancel}
          disabled={!hasSession}
        >
          {t('auth.qrSignIn.cancel')}
        </Button>
      )}

      {showPasswordToggle && onSwitchToPassword && (
        <Flex justify="center">
          <AuthLink onClick={onSwitchToPassword}>
            {t('auth.emailOtp.usePasswordInstead')}
          </AuthLink>
        </Flex>
      )}
    </Flex>
  )
}
